module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/blur-67b43dc783f27681303f35fb71ac9ae6.png";